(function (app) {
    "use strict";

    var hMonthDatePickerController = function ($scope, $element, $document, $datepicker) {

        // private attributes
        var self = this;
        var datePickerConfig = { scope: $scope, container: '.month-date-picker-container', minView: 1 };
        var datePicker;
        var dateElementTitle;
        var dateElement;
        var pickerBootstrapContainer;

        // private functions
        var documentClick = function () {datePicker.hide()};
        var titleElementClick = function (e) {e.stopPropagation()};

        // public attributes
        self.DATE_FORMAT = 'MMM yyyy';

        self.prevMonth = function () {
            var month = self.ngModel.getMonth() - 1;
            var year = self.ngModel.getFullYear();

            // month for date start from 0 end with 11
            // if the month -1 so its year before
            if (month === -1) {
                year -= 1;
                month = 11;
            }

            self.ngModel.setYear(year);
            self.ngModel.setMonth(month);
            self.ngModel.setDate(1);

            // trigger changes
            self.onMonthChanges({month: self.ngModel});

            // update bootstrap date-picker view
            datePicker.update(self.ngModel);
        };

        self.nextMonth = function () {
            var month = self.ngModel.getMonth() + 1;
            var year = self.ngModel.getFullYear();

            // month for date start from 0 end with 11
            // if the month 12 so its year after
            if (month === 12) {
                year += 1;
                month = 0;
            }

            self.ngModel.setYear(year);
            self.ngModel.setMonth(month);
            self.ngModel.setDate(1);

            // trigger changes
            self.onMonthChanges({month: self.ngModel});

            // update bootstrap date-picker view
            datePicker.update(self.ngModel);
        };

        // show the bootstrap date picker
        self.showDatePicker = function () {
            datePicker.setMode(0);
            datePicker.update(self.ngModel);
            datePicker.toggle();
        };

        // listen to changes for model from outside of this component
        self.$onChanges = function (changesObj) {

            if (
                !changesObj.ngModel.isFirstChange() &&
                JSON.stringify(changesObj.ngModel.currentValue) !== JSON.stringify(changesObj.ngModel.previousValue)
            ) {
                var newNgModel = angular.copy(changesObj.ngModel.currentValue);

                // this can be parsed by any browser even if you send moment to this
                if (isNaN(Date.parse(String(newNgModel)))) {
                    throw new Error('Model must be parse by the date constructor on th JS', Date.now());
                }

                self.ngModel = new Date(newNgModel);
                self.ngModel.setDate(1);

                // update bootstrap date-picker view
                datePicker.update(self.ngModel);
            }
        };

        self.$onInit = function () {

            if (typeof (self.ngModel) !== 'undefined') {
                if (isNaN(Date.parse(String(self.ngModel)))) {
                    throw new Error('Model must be parse by the date constructor on th JS', Date.now());
                }

                self.ngModel = new Date(self.ngModel);
                self.ngModel.setDate(1);
            }
        };

        // extend angular-strap datepicker
        // assign events
        self.$postLink = function () {
            dateElement = $element.find("input[name='date']");
            dateElementTitle = $element.find(".month-picker-title");
            pickerBootstrapContainer = $element.find(".month-date-picker-container");

            // define datepicker after the view done render
            datePicker = $datepicker(dateElement, self.ngModel, datePickerConfig);

            // update bootstrap date-picker view
            datePicker.update(self.ngModel);

            // extend select function from angular strap
            datePicker.select = function (date) {
                self.ngModel = date;
                self.ngModel.setDate(1);

                // update bootstrap date-picker view
                datePicker.update(self.ngModel);

                // trigger changes
                self.onMonthChanges({month: self.ngModel});
            };

            // events assign
            dateElementTitle.on('click', titleElementClick);
            pickerBootstrapContainer.on('click', titleElementClick);

            // assign document event
            $document.on('click', documentClick);
        };

        // on destroy function
        // clear events and variables
        self.$onDestroy = function () {
            dateElementTitle.off('click', titleElementClick);
            pickerBootstrapContainer.off('click', titleElementClick);
            $document.off('click', documentClick);
            self.ngModel = null;
            datePicker = null;
        };
    };

    var hMonthDatePickerComponent = {
        bindings: {
            ngModel: '<',
            onMonthChanges: '&'
        },
        templateUrl: '../scripts/global-directives/html/h_month_date_picker.html',
        controllerAs: 'hMonthDatePicker',
        controller: [
            '$scope',
            '$element',
            '$document',
            '$datepicker',
            hMonthDatePickerController
        ]
    };

    app.component('hMonthDatePicker', hMonthDatePickerComponent);

})(angular.module('harriApp'));
